import React from "react";
import { FileText, FileSpreadsheet, File, Download } from "lucide-react";
import Sidebar from "../Sidebar";
import FormalLong from "./Formal-mentoring-agreement-model_Long.docx";
import FormalShort from "./Formal-mentoring-agreement-short.docx";
import Learner from "./Learner-centred-mentoring-paradigm.pdf";
import Confidentiality from "./Mentor-mentee-confidentiality-checklist.pdf";
import Points from "./Mentor-mentee-points-of-connection.pdf";
import Planning from "./Mentoring Planning Worksheet .xlsx";
import Checklist from "./Mentors-readiness-checklist.pdf";
import Smart from "./Smart-goals-worksheet.pdf";
import Tips from "./Tips-for-mentors-in-providing-feedback.pdf";
import WelcomeCard from "../WelcomeCard";

const documents = [
  {
    name: "Formal Mentoring Agreement Model Long",
    url: FormalLong,
  },
  {
    name: "Formal Mentoring Agreement Short",
    url: FormalShort,
  },
  {
    name: "Learner Centred Mentoring Paradigm",
    url: Learner,
  },
  {
    name: "Mentor Mentee Confidentiality Checklist",
    url: Confidentiality,
  },
  {
    name: "Mentor Mentee Points Of Connection",
    url: Points,
  },
  {
    name: "Mentoring Planning Worksheet",
    url: Planning,
  },
  {
    name: "Mentors Readiness Checklist",
    url: Checklist,
  },
  {
    name: "Smart Goals Worksheet",
    url: Smart,
  },
  {
    name: "Tips For Mentors In Providing Feedback.",
    url: Tips,
  },
];

const getFileIcon = (filename) => {
  if (filename.endsWith(".pdf")) return <FileText className="text-red-500" />;
  if (filename.endsWith(".xlsx"))
    return <FileSpreadsheet className="text-green-500" />;
  if (filename.endsWith(".docx")) return <File className="text-blue-500" />;
  return <File />;
};

const DocumentsList = () => {
  return (
    <Sidebar>
      <WelcomeCard title={"Resources"} />
      <div className="mt-8 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {documents.map((doc, idx) => (
            <div
              key={idx}
              className="bg-white border border-gray-200 rounded-2xl p-5 flex items-center justify-between 
                         shadow-md hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300 group"
            >
              <div className="flex items-center gap-4 overflow-hidden">
                <div className="p-2 bg-gray-100 rounded-full group-hover:animate-pulse">
                  {getFileIcon(doc.url)}
                </div>
                <span className="text-gray-800 font-medium truncate max-w-[180px]">
                  {doc.name}
                </span>
              </div>
              <a
                href={doc.url}
                download
                className="text-blue-600 hover:text-blue-800"
                title="Download"
              >
                <Download className="w-5 h-5" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </Sidebar>
  );
};

export default DocumentsList;
